var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgencyActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3882 6.69848C11.3882 8.17829 10.1886 9.37791 8.70873 9.37791C7.22892 9.37791 6.0293 8.17829 6.0293 6.69848C6.0293 5.21867 7.22892 4.01904 8.70873 4.01904C10.1886 4.01904 11.3882 5.21867 11.3882 6.69848ZM8.70873 8.03819C9.44865 8.03819 10.0484 7.43839 10.0484 6.69848C10.0484 5.95858 9.44865 5.35876 8.70873 5.35876C7.96883 5.35876 7.36901 5.95858 7.36901 6.69848C7.36901 7.43839 7.96883 8.03819 8.70873 8.03819Z",
    fill: "#834CEE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4163 8.70816C17.4163 10.8717 16.6274 12.851 15.3213 14.3739L16.6365 15.689C17.3339 15.3742 18.1829 15.5035 18.756 16.0766L23.445 20.7656C24.185 21.5055 24.185 22.7051 23.445 23.445C22.7051 24.185 21.5055 24.185 20.7656 23.445L16.0766 18.756C15.5035 18.1829 15.3743 17.3338 15.6891 16.6363L14.3739 15.3213C12.8511 16.6272 10.8718 17.4163 8.70816 17.4163C3.89878 17.4163 0 13.5176 0 8.70816C0 3.89878 3.89878 0 8.70816 0C13.5176 0 17.4163 3.89878 17.4163 8.70816ZM13.972 13.8643C15.274 12.5353 16.0766 10.7155 16.0766 8.70816C16.0766 4.63867 12.7777 1.33972 8.70816 1.33972C4.63867 1.33972 1.33972 4.63867 1.33972 8.70816C1.33972 10.7155 2.14239 12.5353 3.44428 13.8643C3.8428 12.0641 5.44838 10.7177 7.36844 10.7177H10.0479C11.968 10.7177 13.5735 12.0641 13.972 13.8643ZM12.7273 14.8849V14.7369C12.7273 13.257 11.5277 12.0574 10.0479 12.0574H7.36844C5.88863 12.0574 4.68901 13.257 4.68901 14.7369V14.8849C5.84489 15.6386 7.22537 16.0766 8.70816 16.0766C10.191 16.0766 11.5714 15.6386 12.7273 14.8849ZM17.8087 17.0239L22.4977 21.7129C22.7145 21.9297 22.7145 22.281 22.4977 22.4977C22.281 22.7145 21.9297 22.7145 21.7129 22.4977L17.0239 17.8087C16.8073 17.5919 16.8073 17.2405 17.0239 17.0239C17.2407 16.8071 17.5921 16.8071 17.8087 17.0239Z",
    fill: "#834CEE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgencyActive);
export default __webpack_public_path__ + "static/media/agency_active.3534138cc90f3eec8b07b94154b841d4.svg";
export { ForwardRef as ReactComponent };